<template>
  <div class="animate-pulse">
    <div class="bg-gray-200 rounded-xl overflow-hidden">
      <div class="h-48 bg-gray-300"></div>
      <div class="p-4 space-y-3">
        <div class="h-4 bg-gray-300 rounded w-3/4"></div>
        <div class="h-3 bg-gray-300 rounded w-1/2"></div>
        <div class="h-3 bg-gray-300 rounded w-2/3"></div>
      </div>
    </div>
  </div>
</template>